var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"data-comm":"图片预览工具的控制器","data-hash":_vm.hash}})}
var staticRenderFns = []

export { render, staticRenderFns }